export default __webpack_public_path__ + "static/media/unlimitedGifts.eba89e51.png";